import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const bonuses = [{
  id: '01',
  title: 'Spanish Grammar Made Simple',
  value: '12',
  desc: 'A complete grammar reference guide covering every structure in Spanish 1 and Spanish 2 — written in plain English with clear tables, examples, common error analysis, guided practice, independent exercises and mini quizzes with answer keys. Covers ser/estar, adjective agreement, stem-changing verbs, gustar, object pronouns, commands, preterite, imperfect, por vs. para and more.',
  benefit: 'No preparation needed. Open, reference and teach.'
}, {
  id: '02',
  title: 'Spanish Conversation Practice',
  value: '12',
  desc: 'A bank of 100 fully structured speaking activities to develop oral expression and increase student participation — partner conversations, class surveys, role-plays, picture descriptions, speaking games, mini-presentations, discussions and real-life communication tasks across every level and topic.',
  benefit: 'Your students speak more. Your lessons feel more alive.'
}, {
  id: '03',
  title: 'Spanish Assessment and Quiz Bank',
  value: '10',
  desc: 'A complete bank of assessments for Spanish 1 and Spanish 2 — vocabulary assessments, grammar tests, reading tasks, listening activities, writing prompts, speaking rubrics, unit reviews and mixed-skills assessments. Includes student versions, answer keys, modified versions and retake options.',
  benefit: 'Have the right assessment ready before the week begins.'
}, {
  id: '04',
  title: 'Spanish Culture in the Classroom',
  value: '12',
  desc: 'A collection of 30 complete culture lessons covering the Spanish-speaking world — from Spain to Mexico, Colombia, Argentina, Peru, Chile, Central America and the Caribbean. Food traditions, music, dance, art, literature, festivals, school life and cultural identity, each with reading, vocabulary, discussion and writing.',
  benefit: 'Your cultural lessons feel authentic, not generic.'
}, {
  id: '05',
  title: 'Emergency Spanish Lessons',
  value: '12',
  desc: 'A collection of 30 complete backup classes for the days when there is no time to plan — substitute coverage, unexpected schedule changes or a week when everything ran over. Spanish 1 and Spanish 2 review lessons, grammar practice, reading, speaking challenges, vocabulary review and mini projects, all with answer keys.',
  benefit: 'You will never walk into a Spanish class unprepared again. Open, choose, teach.'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-navy-card border-y border-navy-border" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <p className="text-gold font-bold tracking-widest uppercase mb-2" data-id="element-18">
            Included at no extra cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold" data-id="element-19">
            🎁 The 5 Strategic Bonuses
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-20">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-black border border-gold/20 rounded-2xl p-8 relative group hover:border-gold/50 transition-colors" data-id="element-21">
              <div className="absolute top-0 right-0 bg-gold/10 text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm border-b border-l border-gold/20" data-id="element-22">
                BONUS {bonus.id}
              </div>

              <div className="w-12 h-12 bg-gold/20 rounded-full flex items-center justify-center text-gold mb-6" data-id="element-23">
                <Gift size={24} data-id="element-24" />
              </div>

              <h3 className="text-xl font-serif font-bold mb-2 pr-16" data-id="element-25">
                {bonus.title}
              </h3>

              <div className="inline-block bg-white/5 px-3 py-1 rounded mb-4" data-id="element-26">
                <span className="text-gray-400 text-sm" data-id="element-27">
                  Real value:{' '}
                  <span className="line-through" data-id="element-28">${bonus.value}</span>
                </span>
                <span className="text-gold font-bold ml-2" data-id="element-29">→ FREE</span>
              </div>

              <p className="text-gray-300 text-sm mb-6 leading-relaxed" data-id="element-30">
                {bonus.desc}
              </p>

              <p className="text-gold-light text-sm italic font-medium" data-id="element-31">
                {bonus.benefit}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-r from-gold-dark/20 via-gold/10 to-gold-dark/20 border border-gold/30 rounded-2xl p-8 text-center max-w-2xl mx-auto" data-id="element-32">
          <p className="text-gray-300 mb-2" data-id="element-33">Total value of the 5 bonuses</p>
          <p className="text-2xl text-gray-500 line-through mb-4" data-id="element-34">$58.00</p>
          <p className="text-lg text-white mb-2" data-id="element-35">Your price today</p>
          <p className="text-5xl font-bold text-gold-gradient mb-4" data-id="element-36">🎁 FREE</p>
          <p className="text-sm text-gold-light" data-id="element-37">
            Included only with this offer.
          </p>
        </motion.div>

        <CountdownTimer data-id="element-38" />
      </div>
    </section>;
}